import Text from './components/Text';
import AutoComplete from './components/AutoComplete';

export default {
  Text,
  AutoComplete,
};
